/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs */

const en_ccsl_export_header_dialogue_with_speaker_id = /** @type {(inputs: Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogue With Speaker Id`)
};

const fr_ccsl_export_header_dialogue_with_speaker_id = /** @type {(inputs: Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogue avec ID intervenant`)
};

const de_ccsl_export_header_dialogue_with_speaker_id = /** @type {(inputs: Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialog mit Sprecher-ID`)
};

const it_ccsl_export_header_dialogue_with_speaker_id = /** @type {(inputs: Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogo con ID relatore`)
};

const ru_ccsl_export_header_dialogue_with_speaker_id = /** @type {(inputs: Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Диалог с идентификатором говорящего`)
};

const es_ccsl_export_header_dialogue_with_speaker_id = /** @type {(inputs: Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogo con ID de orador`)
};

const zh_cn2_ccsl_export_header_dialogue_with_speaker_id = /** @type {(inputs: Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与说话人 ID 对话`)
};

const ja_ccsl_export_header_dialogue_with_speaker_id = /** @type {(inputs: Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`話者IDとの対話`)
};

const hi_ccsl_export_header_dialogue_with_speaker_id = /** @type {(inputs: Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ता आईडी के साथ संवाद`)
};

const pt_pt2_ccsl_export_header_dialogue_with_speaker_id = /** @type {(inputs: Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogo com ID do falante`)
};

/**
* | output |
* | --- |
* | "Dialogue With Speaker Id" |
*
* @param {Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_dialogue_with_speaker_id = /** @type {((inputs?: Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_dialogue_with_speaker_id(inputs)
	if (locale === "de") return de_ccsl_export_header_dialogue_with_speaker_id(inputs)
	if (locale === "it") return it_ccsl_export_header_dialogue_with_speaker_id(inputs)
	if (locale === "ru") return ru_ccsl_export_header_dialogue_with_speaker_id(inputs)
	if (locale === "es") return es_ccsl_export_header_dialogue_with_speaker_id(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_dialogue_with_speaker_id(inputs)
	if (locale === "ja") return ja_ccsl_export_header_dialogue_with_speaker_id(inputs)
	if (locale === "hi") return hi_ccsl_export_header_dialogue_with_speaker_id(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_dialogue_with_speaker_id(inputs)
	return en_ccsl_export_header_dialogue_with_speaker_id(inputs)
});